import React,{ useState,useEffect } from 'react'
import {  AppBar, Typography,Button,Toolbar, Avatar, ButtonBase} from '@material-ui/core';
import useStyles from './styles'
import { Link, useHistory, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import decode from 'jwt-decode';
import logo from '../../assets/shopping-bag.svg'

const Navbar = ({ currentId, setCurrentId }) => {
    const [user, setUser] = useState(JSON.parse(localStorage.getItem('profile')));
    const dispatch = useDispatch();
    const location = useLocation();
    const history = useHistory();
    const classes = useStyles();

    const logout = () => {
        dispatch({ type: 'LOGOUT' });
        history.push('/login')
        setUser(null);
    };

    const resetForm = () => {
        setCurrentId(0);
    }
    useEffect(() => {
        //token expiry
        const token = user?.token;
    
        if (token) {
          const decodedToken = decode(token);
    
          if (decodedToken.exp * 1000 < new Date().getTime()) logout();
        }
    
        setUser(JSON.parse(localStorage.getItem('profile')));
        // eslint-disable-next-line
      }, [location]);

    return (
            <AppBar className={classes.appBar} position="fixed" >
                <div className={classes.brand}>
                <ButtonBase component={Link} to='/'>
                <Typography className={classes.heading} variant="h6" align="center">Buy/Sell</Typography>
                <img className={classes.image} src={logo} alt="logo" height="50" />
                </ButtonBase>
                </div>
                <Toolbar className={classes.toolbar}>
                    {user?.result ? (
                        <div className={classes.profile}>
                            <Avatar className={classes.purple} alt={user?.result.username} src={user?.result.imageUrl}>{user?.result.username.charAt(0)}</Avatar>
                            <Typography className={classes.userName} variant="h6">{user.result.username.length > 14 ? user.result.username.slice(0,14) + "..." : user.result.username}</Typography>
                            <Button variant="contained" className={classes.logout} color="primary"  component={Link} to="/form" onClick={resetForm}>Create a new item</Button>
                            <Button variant="contained" className={classes.logout} color="secondary" onClick={logout}>Sign Out</Button>
                        </div>
                    ) : (
                        <div className={classes.signedOut}>
                            <Button variant="contained" color="primary" component={Link} to="/login" className={classes.signin}>Login</Button>
                            <Button variant="contained" color="primary" component={Link} to="/sign-up" className={classes.signin}>Sign Up</Button>
                        </div>
                    )}
                </Toolbar>
            </AppBar>
    )
}

export default Navbar
